import { formatUbCreatedAtRange } from "../utils/ulaanbaatarTime";

const EXPORT_FILTER_KEYS = [
  "id",
  "merchantId",
  "status",
  "paymentMethodId",
  "productTypeId",
  "recipient",
  "purpose",
  "amount",
  "fromAccountNumber",
  "callBackResponse",
  "userId",
  "invoiceItemCount",
  "settleStatus",
];

/**
 * Query params for GET /invoice and GET /invoice/export (same filters as the control table).
 * createdAtOverride — Excel modal date range replaces searchFields.createdAt when set.
 */
export function invoiceSearchParams(searchFields = {}, { createdAtOverride, posOnly } = {}) {
  const params = {};
  const hasInvoiceId =
    searchFields.id != null &&
    searchFields.id !== "" &&
    Number(searchFields.id) > 0;
  const createdAt =
    formatUbCreatedAtRange(createdAtOverride) ||
    formatUbCreatedAtRange(searchFields.createdAt);
  if (createdAt && !hasInvoiceId) {
    params.createdAt = createdAt;
  }
  if (posOnly) {
    params.posOnly = "1";
  }

  EXPORT_FILTER_KEYS.forEach((key) => {
    const value = searchFields[key];
    if (value != null && value !== "") {
      params[key] = value;
    }
  });

  return params;
}

export function invoiceSearchQueryString(searchFields, options) {
  const params = invoiceSearchParams(searchFields, options);
  return Object.keys(params)
    .map((key) => `${key}=${encodeURIComponent(params[key])}`)
    .join("&");
}
